import { EntitySwitch, isResourceType } from "@backstage/plugin-catalog";

import defaultEntityPage from "../default";

import githubRepositoryPage from "./githubRepository";

export default (
  <EntitySwitch>
    <EntitySwitch.Case if={isResourceType("github-repository")}>
      {githubRepositoryPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
